import { getAppStatus } from "single-spa";
import { languages } from "../locale";
import { lang } from "./locale.helpers";
export let hasError = false;
export function enableErrorHandler(err) {
    const brokenApps = ["@platform/mb-app-xbpm-lep"];
    const status = getAppStatus(err.appOrParcelName);
    const errorBlock = document.getElementById("app-load-error");
    // AUL broken status on unmount page reload
    if (brokenApps.includes(err.appOrParcelName)) {
        window.location.reload();
    }
    if (["SKIP_BECAUSE_BROKEN", "LOAD_ERROR"].includes(status)) {
        errorBlock.innerHTML = `<img src="/img/cogs.png" /><p class="error-title">${languages[lang].serviceNotAvailable}</p><p class="error-text">${languages[lang].tryAgainLater}</p><a class="pl-primary-btn error-btn-back" href="/" onclick="singleSpaNavigate(event)">${languages[lang].goBackHome}</a>`;
        hasError = true;
    }
}
export function clearErrorAndCheck404() {
    const errorBlock = document?.getElementById("app-load-error");
    hasError = false;
    if (errorBlock) {
        errorBlock.innerHTML = "";
    }
}
